export const messages = {
  page: {
    title: {
      id: 'messages.Page.Title',
      defaultMessage: 'Messages',
    },
    initialStateMessage: {
      id: 'messages.Page.InitialStateMessage',
      defaultMessage: 'Select an item from the list on the left.',
    },
    zeroStateMessage: {
      id: 'messages.Page.ZeroStateMessage',
      defaultMessage: 'No items to display',
    },
    backButton: {
      id: 'messages.Page.BackButton',
      defaultMessage: 'Back to Messages',
    },
  },
  listPanel: {
    title: {
      id: 'messages.ListPanel.Title',
      defaultMessage: 'Messages',
    },
    emptyMessage: {
      id: 'messages.ListPanel.EmptyMessage',
      defaultMessage: 'No messages are available.',
    },
  },
  filter: {
    current: {
      id: 'messages.Filter.Current',
      defaultMessage: 'Current',
    },
    archive: {
      id: 'messages.Filter.Archive',
      defaultMessage: 'Archive',
    },
  },
  link: {
    newMessage: {
      id: 'messages.Link.NewMessage',
      defaultMessage: 'New Message',
    },
    archive: {
      id: 'messages.Link.Archive',
      defaultMessage: 'Archive',
    },
    unarchive: {
      id: 'messages.Link.Unarchive',
      defaultMessage: 'Unarchive',
    },
    reply: {
      id: 'messages.Link.Reply',
      defaultMessage: 'Reply',
    },
  },
  cancelReplyModal: {
    message: {
      id: 'secureMessage.Reply.Modal.Message',
      defaultMessage: 'You\'ll lose any changes you\'ve made.',
    },
    submitBtnText: {
      id: 'secureMessage.Reply.Modal.SubmitBtnText',
      defaultMessage: 'Yes, I want to cancel',
    },
    hideBtnText: {
      id: 'secureMessage.Reply.Modal.HideBtnText',
      defaultMessage: 'No, take me back',
    },
    title: {
      id: 'secureMessage.Reply.Modal.Title',
      defaultMessage: 'Are you sure?',
    },
  },
  arSenderText: {
    id: 'messages.AuthRepSenderText',
    defaultMessage:
        '{arFirstName} {arLastName} on behalf of {patientFirstName} {patientLastName}',
  },
};
